import { mapGetters } from 'vuex';
import constants from '@/constants';

export default {
  computed: {
    ...mapGetters(['getFeatureSwitch']),

    isWorkScheduleManagerViewFeatureEnabled() {
      return this.getFeatureSwitch(constants.FEATURE_SWITCHES_TITLES.WORK_SCHEDULES_MANAGER_VIEW);
    },

    isWorkScheduleEmployeeViewFeatureEnabled() {
      return this.getFeatureSwitch(constants.FEATURE_SWITCHES_TITLES.WORK_SCHEDULES_EMPLOYEE_VIEW);
    },

    isWorkScheduleRotationFeatureEnabled() {
      return true;
    },
  },
};
